export enum CampaignButtonActions {
  GET_ORIGINAL_FILE = 'GET_ORIGINAL_FILE',
  DOWNLOAD_CLEANSED_FILE = 'DOWNLOAD_CLEANSED_FILE',
  CANCEL_CAMPAIGN = 'CANCEL_CAMPAIGN',
  START_CAMPAIGN = 'START_CAMPAIGN',
}

export enum CampaignComponentScope {
  INDEPENDENT = 'INDEPENDENT',
  ORGANISATION = 'ORGANISATION',
}

export enum BatchStatusEnum {
  DRAFT = 'DRAFT',
  UNDER_REVIEW = 'UNDER REVIEW',
  LIVE = 'LIVE',
  SCHEDULED = 'SCHEDULED',
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  ACTIVE = 'ACTIVE',
}

export enum BatchActionsEnum {
  UPLOAD_EXCLUSION_FILE = 'UPLOAD_EXCLUSION_FILE',
  START_CAMPAIGN = 'START_CAMPAIGN',
  GET_ORIGINAL_FILE = 'GET_ORIGINAL_FILE',
  DOWNLOAD_CLEANSED_FILE = 'DOWNLOAD_CLEANSED_FILE',
  CANCEL_CAMPAIGN = 'CANCEL_CAMPAIGN',
}
